import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _fd-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_option_field = _resolveComponent("option-field")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_base_title, {
      as: "h3",
      uppercase: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.AdfoundNotificationHeader), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_option_field, {
      modelValue: _ctx.model.performanceMarketingDailyReport,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = $event => ((_ctx.model.performanceMarketingDailyReport) = $event)),
        $options.onPerformanceMarketingDailyReportNotificationPreferenceChange
      ],
      "first-column-width": 8,
      options: $setup.basePreferenceOptions,
      "display-name": _ctx.Resources.SubscriptionManagement.PerformanceMarketingDailyReportFieldLabel,
      name: "model.performanceMarketingDailyReport",
      layout: "columns",
      description: _ctx.Resources.SubscriptionManagement.PerformanceMarketingDailyReportFieldDescription,
      "data-qa": "adfound-notifications:PerformanceMarketingDailyReport"
    }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
    _createVNode(_component_option_field, {
      modelValue: _ctx.model.performanceMarketingRecommendation,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = $event => ((_ctx.model.performanceMarketingRecommendation) = $event)),
        $options.onPerformanceMarketingRecommendationNotificationPreferenceChange
      ],
      "first-column-width": 8,
      options: $setup.basePreferenceOptions,
      "display-name": _ctx.Resources.SubscriptionManagement.PerformanceMarketingRecommendationFieldLabel,
      name: "model.performanceMarketingRecommendation",
      layout: "columns",
      description: _ctx.Resources.SubscriptionManagement.PerformanceMarketingRecommendationFieldDescription,
      "data-qa": "adfound-notifications:PerformanceMarketingRecommendation"
    }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
  ]))
}